/* eslint-disable */
import * as d3Selection from 'd3-selection';
import View from './view';

export default class Key extends View {
    constructor(controller, container, config) {
        super(controller, container, config);
        // config
        this.itemHeight = this.config.keyItemHeight || 50;
        this.templates = this.setupTemplates(this.config.templates);

        // by default should expand to fill the key container
        this.width = '100%';
    }

    setupTemplates(userTemplates) {
        const defaultTemplates = {
            all: '{{value}}%',
            min: '< {{value}}',
            max: '> {{value}}',
            extremeMin: false,
        };

        if (userTemplates) {
            return {
                all: userTemplates.all || defaultTemplates.all,
                min: userTemplates.min || defaultTemplates.min,
                max: userTemplates.max || defaultTemplates.max,
                extremeMin: userTemplates.extremeMin || defaultTemplates.extremeMin,
            };
        }

        return defaultTemplates;
    }

    render() {
        if (this.svg) {
            this.container.removeChild(this.svg.node());
        }
        this.svg = d3Selection.select(this.container)
            .append('svg')
            .attr('class', 'map__key-view')
            .attr('role', 'presentation')
            .attr('width', this.width)
            .attr('height', this.itemHeight);

        this.group = this.svg
            .append('g')
            .attr('class', 'key-view__key-items');
    }

    renderData(key, colourScale) {
        this.destroyKeyItems();
        this.renderKeyItem(colourScale);
        this.renderExtremeMin();
    }

    renderKeyItem(scale) {
        // am I an ordinal scale? if so do stuff
        const colours = scale.range();
        const domain = scale.domain();
        const fractionalWidth = 100 / colours.length;
        // const x = d3.scaleLinear()
        //     .domain([0].concat(domain).concat([domain[domain.length] * 2]))
        //     .rangeRound([0, this.width]);
        // const thresholds = scale.domain();
        const itemGroup = this.group
            .append('g')
            .attr('class', 'key-view__key-item');

        itemGroup.selectAll('.key-item__colour')
            .data(colours)
            .enter()
            .append('rect')
                .attr('width', `${fractionalWidth}%`)
                .attr('height', this.itemHeight / 3)
                .attr('x', (d, i) => `${fractionalWidth * i}%`)
                .attr('fill', (d) => d);

        itemGroup.selectAll('.key-item__label')
            .data(domain)
            .enter()
            .append('text')
                .attr('x', (d, i) => `${fractionalWidth * (i + 1)}%`)
                .attr('y', (2.5 / 3) * this.itemHeight)
                .attr('dx', -10)
                .attr('dy', -7)
                .text(this.parseValueLabel.bind(this));
    }

    renderExtremeMin() {
        if(this.templates.extremeMin) {
            this.group
                .append('g')
                .attr('class', 'map__key-label__extreme-min')
                .append('text')
                    .text(() => this.templates.extremeMin)
                    .attr('fill', 'black')
                    .attr('x', 0)
                    .attr('y', (2.5 / 3) * this.itemHeight)
                    .attr('dy', -7);
        }
    }

    parseValueLabel(d, i, a) {
        let textContent = this.templates.all.replace('{{value}}', d);

        if (this.templates.min && i === 0) {
            textContent = this.templates.min.replace('{{value}}', textContent);
        }
        else if (this.templates.max && i === a.length - 1) {
            textContent = this.templates.max.replace('{{value}}', textContent);
        }

        return textContent;
    }

    destroyKeyItems() {
        const groupNode = this.group.node();
        while (groupNode.firstChild) {
            groupNode.removeChild(groupNode.firstChild);
        }
    }
}
